import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export const HeroSection: React.FC = () => {
  return <section className="min-h-screen pt-24 pb-16 px-4 md:px-8 lg:px-16 flex items-center bg-brand-bg overflow-hidden" data-id="element-71">
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col space-y-8 z-10" data-id="element-73">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-primary leading-tight" data-id="element-74">
            Conseguí preparar viandas sabrosas y prácticas para tu semana — y,
            si querés, empezar a venderlas — sin complicarte con cálculos ni
            procesos largos.
          </h1>

          <p className="text-lg md:text-xl text-brand-text-medium font-medium leading-relaxed" data-id="element-75">
            Con COCINA VIANDERA vas a poder cocinar menús semanales listos para
            comer y ofrecerlos a otros incluso si nunca vendiste comida ni tenés
            experiencia profesional.
          </p>

          <div className="flex flex-col space-y-4 pt-4" data-id="element-76">
            <Button fullWidth className="md:w-auto self-start" data-id="element-77">
              QUIERO EMPEZAR AHORA
            </Button>
            <p className="text-sm text-brand-text-medium font-medium flex items-center" data-id="element-78">
              📥 Acceso inmediato + 15 bonos incluidos
            </p>
          </div>

          <div className="flex flex-wrap gap-4 pt-6" data-id="element-79">
            {['Acceso inmediato', '15 Bonos gratis', 'Garantía 2 días'].map((badge, index) => <div key={index} className="flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-sm border border-brand-cream" data-id="element-80">
                  <CheckCircle2 className="w-5 h-5 text-brand-soft" data-id="element-81" />
                  <span className="text-sm font-semibold text-brand-text-dark" data-id="element-82">
                    {badge}
                  </span>
                </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex justify-center lg:justify-end" data-id="element-83">
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative w-full max-w-lg" data-id="element-84">
            <div className="absolute inset-0 bg-brand-soft rounded-full blur-3xl opacity-20 transform scale-110" data-id="element-85"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5hq296twpsLaDaYEzuM1mV/Guia_de_viandas_y_bonos_gratis.jpg" alt="Cocina Viandera Ebook y Bonos" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl" data-id="element-86" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
};